/**
 * VAPID Configuration for Web Push Notifications
 * این فایل تنظیمات VAPID را مدیریت می‌کند
 */

// VAPID Public Key - Generated with npx web-push generate-vapid-keys
export const VAPID_PUBLIC_KEY = 'BNvdCVAwVRGBLAg41n8eG7L588vuNCLpVhONuzociIn01GGdms3CupkJphX0MH2NIKJJTE_Ul6Bc00eFqQKIpr0';

// Worker URL for push notifications
export const PUSH_WORKER_URL = 'https://empty-rain-2654.er-hooman.workers.dev';

// Notification configuration
export const NOTIFICATION_CONFIG = {
  // Default notification options
  defaults: {
    icon: '/logo_pwa.png',
    badge: '/logo_pwa.png',
    vibrate: [200, 100, 200],
    requireInteraction: false,
    silent: false,
  },
  
  // Notification types and their settings
  types: {
    welcome: {
      tag: 'welcome-notification',
      requireInteraction: true,
      priority: 'high',
    },
    analysis: {
      tag: 'analysis-notification',
      requireInteraction: true,
      priority: 'high',
    },
    reminder: {
      tag: 'reminder-notification',
      requireInteraction: false,
      priority: 'normal',
    },
    routine: {
      tag: 'routine-notification',
      requireInteraction: false,
      priority: 'normal',
    },
    general: {
      tag: 'general-notification',
      requireInteraction: false,
      priority: 'normal',
    },
  },
  
  // Retry configuration
  retry: {
    maxAttempts: 3,
    backoffMultiplier: 2,
    initialDelay: 1000,
  },
};

/**
 * Get notification options for a specific type
 * @param {string} type - نوع نوتیفیکیشن
 * @param {Object} customOptions - تنظیمات سفارشی
 * @returns {Object} - تنظیمات کامل نوتیفیکیشن
 */
export function getNotificationOptions(type = 'general', customOptions = {}) {
  const typeConfig = NOTIFICATION_CONFIG.types[type] || NOTIFICATION_CONFIG.types.general;
  
  return {
    ...NOTIFICATION_CONFIG.defaults,
    ...typeConfig,
    ...customOptions,
  };
}

/**
 * Validate VAPID configuration
 * @returns {boolean} - آیا تنظیمات معتبر هستند
 */
export function validateVapidConfig() {
  if (!VAPID_PUBLIC_KEY || VAPID_PUBLIC_KEY.length < 50) {
    console.error('❌ Invalid VAPID_PUBLIC_KEY');
    return false;
  }
  
  if (!PUSH_WORKER_URL) {
    console.error('❌ Invalid PUSH_WORKER_URL');
    return false;
  }
  
  return true;
}

export default {
  VAPID_PUBLIC_KEY,
  PUSH_WORKER_URL,
  NOTIFICATION_CONFIG,
  getNotificationOptions,
  validateVapidConfig,
};

